
import "../style/SparesPage.css";

// Import logos
import jcb from "../assets/jcb.png";
import cat from "../assets/cat.png";
import hyundai from "../assets/hyundai.png";
import kobelco from "../assets/kobelco.png";
import hitachi from "../assets/hitachi.png";

export default function SparesPage() {



  return (
    <div className="spares-container" id="spares">

      

      {/* Header */}
      <div className="spares-header">
        <h1>Machinery Spares</h1>
        <p>All spares are available here</p>
      </div>

      {/* Brand Grid */}
      <div className="spares-grid">
        <div className="logo-item">
          <img src={jcb} alt="JCB" />
        </div>

        <div className="logo-item">
          <img src={cat} alt="CAT" />
        </div>

        <div className="logo-item">
          <img src={hyundai} alt="Hyundai" />
        </div>

        <div className="logo-item">
          <img src={kobelco} alt="Kobelco" />
        </div>

        <div className="logo-item">
          <img src={hitachi} alt="Hitachi" />
        </div>
      </div>

      {/* Contact Section */}
      <div className="spares-contact">
        <h2>Spare Parts Enquiry</h2>
        <p>Need genuine spare parts? Call us anytime</p>

        <a href="tel:04903500300" className="contact-call">
          📞 0490 350 0300
        </a>
      </div>
    </div>
  );
}